export const SIGN_IN = 'SIGN_IN';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const CREATE_ACCOUNT = 'CREATE_ACCOUNT';

